<script>
	import Slider from "./slider.svelte";
	let name = 'you';
</script>

<main>
	<h1>Hello {name}!</h1>
	<input type="text" bind:value={name} />
	<Slider></Slider>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: orangered;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
